<template>
    <div class="socialevents">
        <div class="cards" style="cursor: pointer;">
            <GalleryCard v-for="(card, index) in dataList" 
            :key="index" 
            :title="card.title" 
            :content="card.description.length > 200 ? card.description.substring(0, 200) + '...' : card.description"
            :image="card.image"  
            :date="card.date" 
                  @click="openDetails(card)"
                />
        </div>
    </div>
</template>

<script setup>
import GalleryCard from "./CommonCard/GalleryCard.vue";
import axios from 'axios';
import { ref, onMounted, onBeforeUnmount, watch } from "vue";
import { useRouter, useRoute } from 'vue-router';

const route = useRoute();

const router = useRouter();

let base_url = process.env.VUE_APP_BASE_LIVE_URL
const dataList = ref([]);

watch(
  () => route.query.archive,
  () => {
    listGallery();
  }
);

onMounted( async () => {
  await listGallery();
});

onBeforeUnmount( async () => {
  
});
// Action methods
const listGallery = async () => {
  try {

    const archive = route.query.archive;

    const response = await axios.get('/media_gallery_list_all.php', {
      params: archive ? { archive } : {}
    });

    dataList.value = response.data.data.map(data => ({
      title: data.title,
      description: data.description,
      date: data.date,
      image: `${base_url}/${data.banner_image}` // Construct full image path
    }));

  } catch (error) {
    console.error(error.message);
  }
};
const openDetails = (card)=>{
  router.push({
    name: "MediaGalleryPage",
    params: {
      title: card.title
    }
  });
}
</script>

<style scoped lang="scss">
.socialevents {
    max-width: 95%;
    margin: auto;
    margin-top: 5rem;
}

.btn-active {
    background-color: #ED4E24;
    color: #fff;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border: 2px solid #ED4E24;
    border-radius: 60px;
    width: 103px;
}

.btn-not-active {
    background-color: #fff;
    border: 2px solid #9B9A9A;
    color: #9B9A9A;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border-radius: 60px;
    width: 103px;

}

.buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
    overflow-x: auto;
}

.cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  cursor: pointer;
}

/* Responsive (important) */
@media (max-width: 992px) {
  .cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .cards {
    grid-template-columns: 1fr;
  }
}

.card-title{
    font-size: 48px; 
    font-weight: 400;
}
@media (max-width: 768px) {
    .socialevents {
        max-width: 100%;
        margin: auto;
        margin-top: 2rem;
    }

    .cards {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        margin-top: 5rem;
    }
    .card-title{
        font-size: 35px; 
    }
}
</style>
